// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Employees_modal__img__O1teN {
  height: 7.5rem;
  margin-bottom: 3rem;
}

.Employees_main_nav__l2UGr {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 2rem;
  padding: 0 2rem;
  background-color: var(--color-white);
  border-bottom: solid 1px var(--color-dark);
  border-radius: 1rem 1rem 0 0;
}
.Employees_main_nav__l2UGr > :not(:last-child) {
  margin-right: 1rem;
}
.Employees_main_nav_group__6kpJ4 {
  position: relative;
}
.Employees_main_nav_more__nGDQk {
  position: absolute;
  right: 0;
  top: 75%;
  background-color: var(--color-white);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 5;
}
.Employees_main_nav_more__nGDQk > :not(last-child) {
  margin-bottom: 1rem;
}
.Employees_main_nav_item__v\\+R3s {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
}
.Employees_main_nav_item__v\\+R3s:hover, .Employees_main_nav_item__v\\+R3s:focus, .Employees_main_nav_item__v\\+R3s:focus-visible, .Employees_main_nav_item__v\\+R3s:focus-within {
  font-weight: 700;
  color: var(--color-primary);
  border-bottom: solid 2px var(--color-primary);
}
.Employees_main__metrics__cr8BR {
  box-sizing: border-box;
  padding: 3.5rem 2rem;
  width: 100%;
  display: grid;
  box-sizing: border-box;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 37.5em) {
  .Employees_main__metrics__cr8BR {
    grid-template-columns: repeat(2, 50%);
  }
}
.Employees_main__metrics_active__nmeii {
  background-color: var(--color-green);
  color: var(--color-white);
}
.Employees_main__metrics_suspended__nS7jI {
  background-color: var(--color-yellow);
}
.Employees_main__metrics_terminated__GZiPO {
  background-color: var(--color-error);
  color: var(--color-white);
}
.Employees_main__dropdowns__03GBZ {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  width: 100%;
}
@media only screen and (max-width: 43.75em) {
  .Employees_main__dropdowns__03GBZ {
    flex-direction: column;
    align-items: center;
  }
}
.Employees_main__dropdowns__03GBZ > :not(last-child) {
  margin-right: 2rem;
}
@media only screen and (max-width: 43.75em) {
  .Employees_main__dropdowns__03GBZ > :not(last-child) {
    margin-right: none;
  }
}

.Employees_payroll_table__FOeN\\+ {
  width: 100%;
  margin-top: 3rem;
  font-size: var(--default-font-small);
}
.Employees_payroll_table__FOeN\\+ table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
}
.Employees_payroll_table__FOeN\\+ table tr {
  display: grid;
  grid-template-columns: 5% 18% 15% repeat(2, 12%) 9% 20% 10%;
  padding: 0 1rem;
  align-items: center;
}
@media only screen and (max-width: 50em) {
  .Employees_payroll_table__FOeN\\+ table tr {
    grid-template-columns: 15% 40% 30% 15%;
  }
}
.Employees_payroll_table__FOeN\\+ table th,
.Employees_payroll_table__FOeN\\+ table td {
  padding: 2.2rem 2rem;
}
.Employees_payroll_table__FOeN\\+ table th {
  font-weight: 700;
}
.Employees_payroll_table__FOeN\\+ table td {
  cursor: pointer;
}
.Employees_payroll_table__FOeN\\+ table tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Employees_payroll_table__FOeN\\+ table tbody tr {
  background-color: var(--color-primary-3);
  border-radius: 1.3rem;
}
.Employees_payroll_table__FOeN\\+ table tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
  border-radius: 1.3rem;
}

.Employees_status__pending__Pylnb {
  color: var(--color-yellow-3);
}
.Employees_status__paid__nVplt {
  color: var(--color-green);
}
.Employees_status__failed__jxMeo {
  color: var(--color-error);
}

.Employees_employee__list__1JVFb {
  width: 38rem;
  margin-top: 5rem;
}
.Employees_employee__list__1JVFb li {
  list-style: none;
  cursor: pointer;
}
.Employees_employee__list__1JVFb li:hover {
  font-weight: 700;
  color: var(--color-primary);
}
.Employees_employee__list_line__vj8FF {
  border-top: 1px solid var(--color-primary);
  margin: 2rem 0;
}
.Employees_employee__avatar__G5rsO {
  width: 9rem;
}
.Employees_employee__avatar_container__E3umF {
  width: 10rem;
  height: 10rem;
  border-radius: 7rem;
  border: 1px solid var(--color-primary);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3rem 0;
}
.Employees_employee__details__2nf8l {
  width: 38rem;
}
.Employees_employee__editButton__3ObV8 {
  position: relative;
  right: 17rem;
  display: flex;
  font-size: 2.5rem;
  align-items: center;
  cursor: pointer;
}
.Employees_employee__editButton__3ObV8 > :not(:last-child) {
  margin-right: 1rem;
}
.Employees_employee__terminate__jXrst {
  display: flex;
  flex-direction: column;
  width: 38rem;
}
.Employees_employee__terminate__jXrst > :not(:last-child) {
  margin-bottom: 1rem;
}
.Employees_employee_table__y1O5y {
  width: 100%;
  margin-top: 3rem;
  font-size: var(--default-font-small);
}
.Employees_employee_table__y1O5y table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
}
.Employees_employee_table__y1O5y table tr {
  display: grid;
  grid-template-columns: 16% repeat(3, 15%) 15% 10% 10% 5% 15%;
  padding: 0 1rem;
  align-items: center;
}
@media only screen and (max-width: 50em) {
  .Employees_employee_table__y1O5y table tr {
    grid-template-columns: repeat(2, 40%) 20%;
  }
}
.Employees_employee_table__y1O5y table th,
.Employees_employee_table__y1O5y table td {
  padding: 2.2rem 1rem;
}
.Employees_employee_table__y1O5y table th {
  font-weight: 700;
}
.Employees_employee_table__y1O5y table td {
  cursor: pointer;
}
.Employees_employee_table__y1O5y table tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Employees_employee_table__y1O5y table tbody tr {
  background-color: var(--color-primary-3);
  border-radius: 1.3rem;
}
.Employees_employee_table__y1O5y table tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
  border-radius: 1.3rem;
}
.Employees_employee_table__y1O5y table tbody tr > :last-child {
  font-weight: 700;
}

.Employees_crumbs__eqZhI {
  display: flex;
  margin-top: 2rem;
  margin-bottom: 1rem;
}
.Employees_crumbs__eqZhI > :not(:last-child) {
  margin-right: 2rem;
}
.Employees_crumbs__main__VMfqa {
  content: "";
  height: 2rem;
  width: 2rem;
  border-radius: 2rem;
  background-color: var(--color-grey);
}
.Employees_crumbs__active__QkU8K {
  width: 5rem;
  background-color: var(--color-primary);
}

.Employees_checks__W5\\+wT {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.Employees_checks__W5\\+wT > :not(:last-child) {
  margin-right: 1rem;
}
.Employees_checks_group__4O9wg {
  width: 38rem;
}

.Employees_gp__TyFVa {
  width: 40rem;
}
.Employees_gp__vb__fHJBB {
  position: relative;
  left: 20rem;
}
.Employees_gp__vps__VVdDK {
  position: relative;
  left: 16.5rem;
}
.Employees_gp__top__canHY {
  display: flex;
  justify-content: space-between;
  width: 44rem;
  margin-bottom: 3rem;
}
.Employees_gp__TyFVa table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
}
.Employees_gp__TyFVa table tr {
  display: grid;
  grid-template-columns: 2.6fr repeat(2, 1.2fr);
  align-items: center;
  border-bottom: 1px solid var(--color-primary);
}
.Employees_gp__TyFVa table th {
  font-weight: 700;
  color: var(--color-primary);
}
.Employees_gp__TyFVa table td {
  cursor: pointer;
}
.Employees_gp__TyFVa table tbody > :first-child {
  margin-top: 1rem;
}
.Employees_gp__TyFVa table tbody > * {
  padding: 1rem 0;
}
.Employees_gp__TyFVa table tbody tr > :first-child {
  font-weight: 700;
}

.Employees_ps__Tglf\\+ {
  width: 40rem;
}
.Employees_ps__breakdown__oXp7G {
  width: 38rem;
}
.Employees_ps__breakdown_sm__JPWtB {
  font-size: var(--default-font-small);
}
.Employees_ps__breakdown_bdr__ByQl\\+ {
  border-bottom: 1px solid var(--color-primary);
}
.Employees_ps__breakdown_total__1AC1c {
  font-size: var(--default-font-small);
}
.Employees_ps__breakdown__oXp7G table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font);
}
.Employees_ps__breakdown__oXp7G table thead tr,
.Employees_ps__breakdown__oXp7G table tbody tr {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
}
.Employees_ps__breakdown__oXp7G table thead tr > :first-child,
.Employees_ps__breakdown__oXp7G table tbody tr > :first-child {
  justify-self: start;
  font-weight: 400;
}
.Employees_ps__breakdown__oXp7G table thead tr > :last-child,
.Employees_ps__breakdown__oXp7G table tbody tr > :last-child {
  justify-self: end;
  font-weight: 700;
}
.Employees_ps__breakdown__oXp7G table thead > *,
.Employees_ps__breakdown__oXp7G table tbody > * {
  padding: 1rem 0;
}
.Employees_ps__breakdown__oXp7G table th {
  color: var(--color-primary);
}

.Employees_mp__Ue2DD {
  width: 38rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Employees_success__I3dKY {
  height: 27rem;
  margin-bottom: 3rem;
}

.Employees_simpleTable__YSclX {
  width: 100%;
  margin-top: 3rem;
  font-size: 1.2rem;
}
.Employees_simpleTable__YSclX table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  margin-top: 2rem;
}
.Employees_simpleTable__YSclX table tr {
  padding: 0 1rem;
  align-items: center;
}
.Employees_simpleTable__YSclX table th,
.Employees_simpleTable__YSclX table td {
  padding: 1.2rem 2rem;
}
.Employees_simpleTable__YSclX table th {
  font-weight: 700;
}
.Employees_simpleTable__YSclX table thead {
  margin-bottom: 2rem;
}
.Employees_simpleTable__YSclX table thead tr {
  background-color: var(--color-dark);
  border-radius: 1rem;
  color: var(--color-white);
}
.Employees_simpleTable__YSclX table tbody tr {
  background-color: var(--color-white);
}
.Employees_simpleTable__YSclX table tbody tr:nth-child(even) {
  background-color: var(--color-table-grey);
}
.Employees_simpleTable__YSclX table .Employees_pending__WuNBH {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-yellow);
  color: var(--color-dark);
  margin-top: 0.7rem;
  width: 100%;
}
.Employees_simpleTable__YSclX table .Employees_paid__X5mMf {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-success);
  color: var(--color-white);
  margin-top: 0.7rem;
  width: 100%;
}
.Employees_simpleTable__YSclX table .Employees_failed__YzBHY {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-error);
  color: var(--color-white);
  margin-top: 0.7rem;
  width: 100%;
}
.Employees_simpleTable__YSclX table .Employees_others__rBVOq {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-dark);
  color: var(--color-white);
  margin-top: 0.7rem;
  width: 100%;
}
.Employees_simpleTable__YSclX table .Employees_change__MWNPO {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-primary);
  color: var(--color-white);
  margin-top: 0.7rem;
  width: 100%;
}
.Employees_simpleTable__YSclX table .Employees_action__text__zJqyc {
  font-weight: 600;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
}

.Employees_filter__Q8r32 {
  position: absolute;
  width: -moz-fit-content;
  width: fit-content;
  right: 0;
  top: 75%;
  background-color: var(--color-white);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 3;
}
@media only screen and (max-width: 31.25em) {
  .Employees_filter__Q8r32 {
    top: 95%;
  }
}
.Employees_filter_title__NBjUX {
  width: 100%;
  font-size: var(--default-font-small);
  background-color: var(--color-light);
  padding: 1rem;
}
.Employees_filter_title__NBjUX > :not(:last-child) {
  margin-right: 1.5rem;
}
.Employees_filter_group__IIwzg {
  display: flex;
  flex-wrap: wrap;
}
.Employees_filter_group__IIwzg > :not(:last-child) {
  margin-right: 1rem;
}
.Employees_filter_item__ZCidk {
  font-size: 1.2rem;
  padding: 0.5rem;
  border: 1px solid var(--color-dark);
  border-radius: 0.8rem;
  cursor: pointer;
  margin-bottom: 1rem;
}
.Employees_filter_selectedItem__CHkss {
  font-size: 1.2rem;
  padding: 0.5rem;
  border: 1px solid var(--color-dark);
  border-radius: 0.8rem;
  cursor: pointer;
  color: var(--color-white);
  font-weight: 700;
  background-color: var(--color-dark);
  margin-bottom: 1rem;
}

.Employees_cpt__21wmP {
  display: flex;
  font-size: var(--default-font-small);
  width: 38rem;
  overflow-x: scroll;
}
.Employees_cpt__21wmP::-webkit-scrollbar {
  width: 1rem;
  background-color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
}
.Employees_cpt__21wmP::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
  border-radius: 1rem;
}
.Employees_cpt_action__78VjD {
  font-weight: 700;
  color: var(--color-primary);
  cursor: pointer;
  text-decoration: underline;
}
.Employees_cpt__21wmP tr {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem;
}
.Employees_cpt__21wmP thead {
  background-color: var(--color-grey-3);
  width: 19rem;
  position: fixed;
  z-index: 2;
}
.Employees_cpt__21wmP tbody {
  position: relative;
  left: 50%;
  display: flex;
}
.Employees_cpt__21wmP tbody tr {
  background-color: var(--color-light);
  width: 19rem;
}
.Employees_cpt__21wmP tbody tr:nth-child(even) {
  background-color: var(--color-white);
}

.Employees_beneficiary__oE\\+3p {
  display: grid;
  grid-template-columns: 1fr 1fr;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  width: 38rem;
  margin-bottom: 3rem;
  cursor: pointer;
}
.Employees_beneficiary__oE\\+3p > * {
  padding: 1rem 0 1rem 0;
  text-align: center;
}
.Employees_beneficiary__saved__H\\+iUN {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.Employees_beneficiary__saved_b__3Oczd {
  border: 1px solid var(--color-primary);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.Employees_beneficiary__new__jeg3P {
  border: 1px solid var(--color-primary);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}
.Employees_beneficiary__new_b__jgysk {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}

.Employees_unit_group__DIONm {
  width: 38rem;
  display: grid;
  grid-template-columns: repeat(2, 50%);
  gap: 2rem;
}
.Employees_unit_card__G0gt4 {
  background-color: var(--color-primary-3);
  padding: 2rem;
  box-sizing: border-box;
  border-radius: 2rem;
  font-size: 4rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: var(--color-primary);
  cursor: pointer;
  transition: all 0.4s;
}
.Employees_unit_card__G0gt4:hover {
  background-color: var(--color-primary-7);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employees/Employees.module.scss"],"names":[],"mappings":"AAGC;EACC,cAAA;EACA,mBAAA;AAFF;;AAOC;EACC,aAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EAEA,oCAAA;EACA,0CAAA;EACA,4BAAA;AALF;AAOE;EACC,kBAAA;AALH;AAQE;EACC,kBAAA;AANH;AASE;EACC,kBAAA;EACA,QAAA;EACA,QAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AAPH;AASG;EACC,mBAAA;AAPJ;AAWE;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;AATH;AAeG;EAIC,gBAAA;EACA,2BAAA;EACA,6CAAA;AAhBJ;AAqBC;EACC,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,SAAA;AAnBF;AAqBE;EATD;IAUE,qCAAA;EAlBD;AACF;AAoBE;EACC,oCAAA;EACA,yBAAA;AAlBH;AAoBE;EACC,qCAAA;AAlBH;AAoBE;EACC,oCAAA;EACA,yBAAA;AAlBH;AAsBC;EACC,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AApBF;AAsBE;EAND;IAOE,sBAAA;IACA,mBAAA;EAnBD;AACF;AAqBE;EACC,kBAAA;AAnBH;AAoBG;EAFD;IAGE,kBAAA;EAjBF;AACF;;AAuBC;EACC,WAAA;EACA,gBAAA;EACA,oCAAA;AApBF;AAsBE;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AApBH;AAsBG;EACC,aAAA;EACA,2DAAA;EACA,eAAA;EACA,mBAAA;AApBJ;AAsBI;EAND;IAOE,sCAAA;EAnBH;AACF;AA0BG;;EAEC,oBAAA;AAxBJ;AA2BG;EACC,gBAAA;AAzBJ;AA4BG;EACC,eAAA;AA1BJ;AA8BI;EACC,qBAAA;AA5BL;AA+BI;EACC,wCAAA;EACA,qBAAA;AA7BL;AA+BK;EACC,wCAAA;EACA,qBAAA;AA7BN;;AAsCC;EACC,4BAAA;AAnCF;AAqCC;EACC,yBAAA;AAnCF;AAqCC;EACC,yBAAA;AAnCF;;AAuCC;EACC,YAAA;EACA,gBAAA;AApCF;AAqCE;EACC,gBAAA;EACA,eAAA;AAnCH;AAqCG;EACC,gBAAA;EACA,2BAAA;AAnCJ;AAuCE;EACC,0CAAA;EACA,cAAA;AArCH;AAyCC;EACC,WAAA;AAvCF;AAyCE;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAvCH;AA2CC;EACC,YAAA;AAzCF;AA4CC;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AA1CF;AA4CE;EACC,kBAAA;AA1CH;AA6CC;EACC,aAAA;EACA,sBAAA;EACA,YAAA;AA3CF;AA6CE;EACC,mBAAA;AA3CH;AA8CC;EACC,WAAA;EACA,gBAAA;EACA,oCAAA;AA5CF;AA8CE;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AA5CH;AA8CG;EACC,aAAA;EACA,4DAAA;EACA,eAAA;EACA,mBAAA;AA5CJ;AA8CI;EAND;IAOE,yCAAA;EA3CH;AACF;AAkDG;;EAEC,oBAAA;AAhDJ;AAmDG;EACC,gBAAA;AAjDJ;AAoDG;EACC,eAAA;AAlDJ;AAsDI;EACC,qBAAA;AApDL;AAuDI;EACC,wCAAA;EACA,qBAAA;AArDL;AAuDK;EACC,wCAAA;EACA,qBAAA;AArDN;AAwDK;EACC,gBAAA;AAtDN;;AA8DA;EACC,aAAA;EACA,gBAAA;EACA,mBAAA;AA3DD;AA4DC;EACC,kBAAA;AA1DF;AA6DC;EACC,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mCAAA;AA3DF;AA6DC;EACC,WAAA;EACA,sCAAA;AA3DF;;AA+DA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AA5DD;AA6DC;EACC,kBAAA;AA3DF;AA8DC;EACC,YAAA;AA5DF;;AAgEA;EACC,YAAA;AA7DD;AA+DC;EACC,kBAAA;EACA,WAAA;AA7DF;AAgEC;EACC,kBAAA;EACA,aAAA;AA9DF;AAiEC;EACC,aAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;AA/DF;AAkEC;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;AAhEF;AAkEE;EACC,aAAA;EACA,6CAAA;EACA,mBAAA;EACA,6CAAA;AAhEH;AA2EE;EACC,gBAAA;EACA,2BAAA;AAzEH;AA4EE;EACC,eAAA;AA1EH;AA8EG;EACC,gBAAA;AA5EJ;AA8EG;EACC,eAAA;AA5EJ;AAgFI;EACC,gBAAA;AA9EL;;AAqFA;EACC,YAAA;AAlFD;AAoFC;EACC,YAAA;AAlFF;AAmFE;EACC,oCAAA;AAjFH;AAoFE;EACC,6CAAA;AAlFH;AAqFE;EACC,oCAAA;AAnFH;AAsFE;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,8BAAA;AApFH;AAwFI;;EACC,aAAA;EACA,qCAAA;EACA,mBAAA;AArFL;AAuFK;;EACC,mBAAA;EACA,gBAAA;AApFN;AAsFK;;EACC,iBAAA;EACA,gBAAA;AAnFN;AAuFI;;EACC,eAAA;AApFL;AAwFG;EACC,2BAAA;AAtFJ;;AA4FA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAzFD;;AA4FA;EACC,aAAA;EACA,mBAAA;AAzFD;;AA4FA;EACC,WAAA;EACA,gBAAA;EACA,iBAAA;AAzFD;AA2FC;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AAzFF;AA2FE;EACC,eAAA;EACA,mBAAA;AAzFH;AA4FE;;EAEC,oBAAA;AA1FH;AA6FE;EACC,gBAAA;AA3FH;AA8FE;EACC,mBAAA;AA5FH;AA6FG;EACC,mCAAA;EACA,mBAAA;EACA,yBAAA;AA3FJ;AAgGG;EACC,oCAAA;AA9FJ;AAgGI;EACC,yCAAA;AA9FL;AAmGE;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;AAjGH;AAoGE;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,sCAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AAlGH;AAqGE;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AAnGH;AAsGE;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,mCAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AApGH;AAuGE;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,sCAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AArGH;AAwGE;EACC,gBAAA;EACA,2BAAA;EACA,0BAAA;EACA,eAAA;AAtGH;;AA2GA;EACC,kBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AAxGD;AAyGC;EAVD;IAWE,QAAA;EAtGA;AACF;AAiHC;EACC,WAAA;EACA,oCAAA;EACA,oCAAA;EACA,aAAA;AA/GF;AAgHE;EACC,oBAAA;AA9GH;AAkHC;EACC,aAAA;EACA,eAAA;AAhHF;AAkHE;EACC,kBAAA;AAhHH;AAoHC;EACC,iBAAA;EACA,eAAA;EACA,mCAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;AAlHF;AAoHC;EACC,iBAAA;EACA,eAAA;EACA,mCAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,mCAAA;EACA,mBAAA;AAlHF;;AAsHA;EACC,aAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;AAnHD;AAoHC;EACC,WAAA;EACA,oCAAA;EACA,4BAAA;AAlHF;AAqHC;EACC,mCAAA;EACA,mBAAA;AAnHF;AAsHC;EACC,gBAAA;EACA,2BAAA;EACA,eAAA;EACA,0BAAA;AApHF;AAuHC;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AArHF;AAwHC;EACC,qCAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AAtHF;AAwHC;EACC,kBAAA;EACA,SAAA;EACA,aAAA;AAtHF;AAuHE;EACC,oCAAA;EACA,YAAA;AArHH;AAuHG;EACC,oCAAA;AArHJ;;AA2HA;EACC,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,oCAAA;EACA,YAAA;EAEA,mBAAA;EACA,eAAA;AAzHD;AA2HC;EACC,sBAAA;EACA,kBAAA;AAzHF;AA4HC;EACC,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AA1HF;AA4HE;EACC,sCAAA;EACA,4BAAA;EACA,oBAAA;AA1HH;AA8HC;EACC,sCAAA;EACA,4BAAA;EACA,oBAAA;AA5HF;AA8HE;EACC,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AA5HH;;AAkIC;EACC,YAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AA/HF;AAkIC;EACC,wCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,oBAAA;AAhIF;AAkIE;EACC,wCAAA;AAhIH","sourcesContent":["@import '../variables/breakpoints';\n\n.modal {\n\t&__img {\n\t\theight: 7.5rem;\n\t\tmargin-bottom: 3rem;\n\t}\n}\n\n.main {\n\t&_nav {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tflex-wrap: wrap;\n\t\tmargin-top: 2rem;\n\t\tpadding: 0 2rem;\n\t\t// border-top: solid 1px var(--color-primary);\n\t\tbackground-color: var(--color-white);\n\t\tborder-bottom: solid 1px var(--color-dark);\n\t\tborder-radius: 1rem 1rem 0 0;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\n\t\t&_group {\n\t\t\tposition: relative;\n\t\t}\n\n\t\t&_more {\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t\ttop: 75%;\n\t\t\tbackground-color: var(--color-white);\n\t\t\tpadding: 1.5rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\t\tz-index: 5;\n\n\t\t\t& > :not(last-child) {\n\t\t\t\tmargin-bottom: 1rem;\n\t\t\t}\n\t\t}\n\n\t\t&_item {\n\t\t\tcursor: pointer;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tfont-size: var(--default-font-small);\n\n\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t// \twidth: 47%;\n\t\t\t// }\n\n\t\t\t&:hover,\n\t\t\t&:focus,\n\t\t\t&:focus-visible,\n\t\t\t&:focus-within {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tborder-bottom: solid 2px var(--color-primary);\n\t\t\t}\n\t\t}\n\t}\n\n\t&__metrics {\n\t\tbox-sizing: border-box;\n\t\tpadding: 3.5rem 2rem;\n\t\twidth: 100%;\n\t\tdisplay: grid;\n\t\tbox-sizing: border-box;\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t\tgap: 2rem;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: repeat(2, 50%);\n\t\t}\n\n\t\t&_active {\n\t\t\tbackground-color: var(--color-green);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\t\t&_suspended {\n\t\t\tbackground-color: var(--color-yellow);\n\t\t}\n\t\t&_terminated {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\t}\n\n\t&__dropdowns {\n\t\tmargin-top: 2rem;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\twidth: 100%;\n\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t}\n\n\t\t& > :not(last-child) {\n\t\t\tmargin-right: 2rem;\n\t\t\t@media only screen and (max-width: $bp-700) {\n\t\t\t\tmargin-right: none;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.payroll {\n\t&_table {\n\t\twidth: 100%;\n\t\tmargin-top: 3rem;\n\t\tfont-size: var(--default-font-small);\n\n\t\ttable {\n\t\t\twidth: 100%;\n\t\t\tmax-width: 100%;\n\t\t\tborder: none;\n\t\t\tborder-collapse: collapse;\n\t\t\tbox-sizing: border-box;\n\t\t\ttext-align: left;\n\n\t\t\ttr {\n\t\t\t\tdisplay: grid;\n\t\t\t\tgrid-template-columns: 5% 18% 15% repeat(2, 12%) 9% 20% 10%;\n\t\t\t\tpadding: 0 1rem;\n\t\t\t\talign-items: center;\n\n\t\t\t\t@media only screen and (max-width: $bp-800) {\n\t\t\t\t\tgrid-template-columns: 15% 40% 30% 15%;\n\t\t\t\t}\n\n\t\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t\t// \tgrid-template-columns: 1fr;\n\t\t\t\t// }\n\t\t\t}\n\n\t\t\tth,\n\t\t\ttd {\n\t\t\t\tpadding: 2.2rem 2rem;\n\t\t\t}\n\n\t\t\tth {\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\n\t\t\ttd {\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\ttbody {\n\t\t\t\t& > :not(:last-child) {\n\t\t\t\t\tmargin-bottom: 1.5rem;\n\t\t\t\t}\n\n\t\t\t\ttr {\n\t\t\t\t\tbackground-color: var(--color-primary-3);\n\t\t\t\t\tborder-radius: 1.3rem;\n\n\t\t\t\t\t&:nth-child(even) {\n\t\t\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\t\t\tborder-radius: 1.3rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.status {\n\t&__pending {\n\t\tcolor: var(--color-yellow-3);\n\t}\n\t&__paid {\n\t\tcolor: var(--color-green);\n\t}\n\t&__failed {\n\t\tcolor: var(--color-error);\n\t}\n}\n.employee {\n\t&__list {\n\t\twidth: 38rem;\n\t\tmargin-top: 5rem;\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t}\n\n\t\t&_line {\n\t\t\tborder-top: 1px solid var(--color-primary);\n\t\t\tmargin: 2rem 0;\n\t\t}\n\t}\n\n\t&__avatar {\n\t\twidth: 9rem;\n\n\t\t&_container {\n\t\t\twidth: 10rem;\n\t\t\theight: 10rem;\n\t\t\tborder-radius: 7rem;\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tmargin: 3rem 0;\n\t\t}\n\t}\n\n\t&__details {\n\t\twidth: 38rem;\n\t}\n\n\t&__editButton {\n\t\tposition: relative;\n\t\tright: 17rem;\n\t\tdisplay: flex;\n\t\tfont-size: 2.5rem;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\t}\n\t&__terminate {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 38rem;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\t}\n\t&_table {\n\t\twidth: 100%;\n\t\tmargin-top: 3rem;\n\t\tfont-size: var(--default-font-small);\n\n\t\ttable {\n\t\t\twidth: 100%;\n\t\t\tmax-width: 100%;\n\t\t\tborder: none;\n\t\t\tborder-collapse: collapse;\n\t\t\tbox-sizing: border-box;\n\t\t\ttext-align: left;\n\n\t\t\ttr {\n\t\t\t\tdisplay: grid;\n\t\t\t\tgrid-template-columns: 16% repeat(3, 15%) 15% 10% 10% 5% 15%;\n\t\t\t\tpadding: 0 1rem;\n\t\t\t\talign-items: center;\n\n\t\t\t\t@media only screen and (max-width: $bp-800) {\n\t\t\t\t\tgrid-template-columns: repeat(2, 40%) 20%;\n\t\t\t\t}\n\n\t\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t\t// \tgrid-template-columns: 1fr;\n\t\t\t\t// }\n\t\t\t}\n\n\t\t\tth,\n\t\t\ttd {\n\t\t\t\tpadding: 2.2rem 1rem;\n\t\t\t}\n\n\t\t\tth {\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\n\t\t\ttd {\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\ttbody {\n\t\t\t\t& > :not(:last-child) {\n\t\t\t\t\tmargin-bottom: 1.5rem;\n\t\t\t\t}\n\n\t\t\t\ttr {\n\t\t\t\t\tbackground-color: var(--color-primary-3);\n\t\t\t\t\tborder-radius: 1.3rem;\n\n\t\t\t\t\t&:nth-child(even) {\n\t\t\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\t\t\tborder-radius: 1.3rem;\n\t\t\t\t\t}\n\n\t\t\t\t\t& > :last-child {\n\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.crumbs {\n\tdisplay: flex;\n\tmargin-top: 2rem;\n\tmargin-bottom: 1rem;\n\t& > :not(:last-child) {\n\t\tmargin-right: 2rem;\n\t}\n\n\t&__main {\n\t\tcontent: '';\n\t\theight: 2rem;\n\t\twidth: 2rem;\n\t\tborder-radius: 2rem;\n\t\tbackground-color: var(--color-grey);\n\t}\n\t&__active {\n\t\twidth: 5rem;\n\t\tbackground-color: var(--color-primary);\n\t}\n}\n\n.checks {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-bottom: 2rem;\n\t& > :not(:last-child) {\n\t\tmargin-right: 1rem;\n\t}\n\n\t&_group {\n\t\twidth: 38rem;\n\t}\n}\n\n.gp {\n\twidth: 40rem;\n\n\t&__vb {\n\t\tposition: relative;\n\t\tleft: 20rem;\n\t}\n\n\t&__vps {\n\t\tposition: relative;\n\t\tleft: 16.5rem;\n\t}\n\n\t&__top {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\twidth: 44rem;\n\t\tmargin-bottom: 3rem;\n\t}\n\n\ttable {\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t\tborder: none;\n\t\tborder-collapse: collapse;\n\t\tbox-sizing: border-box;\n\t\ttext-align: left;\n\t\tfont-size: var(--default-font-small);\n\n\t\ttr {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: 2.6fr repeat(2, 1.2fr);\n\t\t\talign-items: center;\n\t\t\tborder-bottom: 1px solid var(--color-primary);\n\n\t\t\t// @media only screen and (max-width: $bp-900) {\n\t\t\t// \tgrid-template-columns: 2.3fr 1.6fr 2fr 0.9fr 0.2fr;\n\t\t\t// }\n\n\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t// \tgrid-template-columns: 1fr;\n\t\t\t// }\n\t\t}\n\n\t\tth {\n\t\t\tfont-weight: 700;\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\n\t\ttd {\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\ttbody {\n\t\t\t& > :first-child {\n\t\t\t\tmargin-top: 1rem;\n\t\t\t}\n\t\t\t& > * {\n\t\t\t\tpadding: 1rem 0;\n\t\t\t}\n\n\t\t\ttr {\n\t\t\t\t& > :first-child {\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ps {\n\twidth: 40rem;\n\n\t&__breakdown {\n\t\twidth: 38rem;\n\t\t&_sm {\n\t\t\tfont-size: var(--default-font-small);\n\t\t}\n\n\t\t&_bdr {\n\t\t\tborder-bottom: 1px solid var(--color-primary);\n\t\t}\n\n\t\t&_total {\n\t\t\tfont-size: var(--default-font-small);\n\t\t}\n\n\t\ttable {\n\t\t\twidth: 100%;\n\t\t\tmax-width: 100%;\n\t\t\tborder: none;\n\t\t\tborder-collapse: collapse;\n\t\t\tbox-sizing: border-box;\n\t\t\ttext-align: left;\n\t\t\tfont-size: var(--default-font);\n\n\t\t\tthead,\n\t\t\ttbody {\n\t\t\t\ttr {\n\t\t\t\t\tdisplay: grid;\n\t\t\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t\t\t\talign-items: center;\n\n\t\t\t\t\t& > :first-child {\n\t\t\t\t\t\tjustify-self: start;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t}\n\t\t\t\t\t& > :last-child {\n\t\t\t\t\t\tjustify-self: end;\n\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t& > * {\n\t\t\t\t\tpadding: 1rem 0;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tth {\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.mp {\n\twidth: 38rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n.success {\n\theight: 27rem;\n\tmargin-bottom: 3rem;\n}\n\n.simpleTable {\n\twidth: 100%;\n\tmargin-top: 3rem;\n\tfont-size: 1.2rem;\n\n\ttable {\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t\tborder: none;\n\t\tborder-collapse: collapse;\n\t\tbox-sizing: border-box;\n\t\ttext-align: left;\n\t\tmargin-top: 2rem;\n\n\t\ttr {\n\t\t\tpadding: 0 1rem;\n\t\t\talign-items: center;\n\t\t}\n\n\t\tth,\n\t\ttd {\n\t\t\tpadding: 1.2rem 2rem;\n\t\t}\n\n\t\tth {\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\tthead {\n\t\t\tmargin-bottom: 2rem;\n\t\t\ttr {\n\t\t\t\tbackground-color: var(--color-dark);\n\t\t\t\tborder-radius: 1rem;\n\t\t\t\tcolor: var(--color-white);\n\t\t\t}\n\t\t}\n\n\t\ttbody {\n\t\t\ttr {\n\t\t\t\tbackground-color: var(--color-white);\n\n\t\t\t\t&:nth-child(even) {\n\t\t\t\t\tbackground-color: var(--color-table-grey);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.pending {\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\tline-height: 1;\n\t\t\tfont-size: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-yellow);\n\t\t\tcolor: var(--color-dark);\n\t\t\tmargin-top: 0.7rem;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.paid {\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\tline-height: 1;\n\t\t\tfont-size: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-success);\n\t\t\tcolor: var(--color-white);\n\t\t\tmargin-top: 0.7rem;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.failed {\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\tline-height: 1;\n\t\t\tfont-size: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t\tmargin-top: 0.7rem;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.others {\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\tline-height: 1;\n\t\t\tfont-size: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-dark);\n\t\t\tcolor: var(--color-white);\n\t\t\tmargin-top: 0.7rem;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.change {\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\tline-height: 1;\n\t\t\tfont-size: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-primary);\n\t\t\tcolor: var(--color-white);\n\t\t\tmargin-top: 0.7rem;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.action__text {\n\t\t\tfont-weight: 600;\n\t\t\tcolor: var(--color-primary);\n\t\t\ttext-decoration: underline;\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n}\n\n.filter {\n\tposition: absolute;\n\twidth: fit-content;\n\tright: 0;\n\ttop: 75%;\n\tbackground-color: var(--color-white);\n\tpadding: 1.5rem;\n\tborder-radius: 1rem;\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tz-index: 3;\n\t@media only screen and (max-width: $bp-500) {\n\t\ttop: 95%;\n\t}\n\t// clip-path: polygon(\n\t// \t48% 10%,\n\t// \t50% 0,\n\t// \t52% 10%,\n\t// \t100% 10%,\n\t// \t100% 100%,\n\t// \t0 100%,\n\t// \t0 10%\n\t// );\n\n\t&_title {\n\t\twidth: 100%;\n\t\tfont-size: var(--default-font-small);\n\t\tbackground-color: var(--color-light);\n\t\tpadding: 1rem;\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 1.5rem;\n\t\t}\n\t}\n\n\t&_group {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\t// margin: 2rem 0;\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\t}\n\n\t&_item {\n\t\tfont-size: 1.2rem;\n\t\tpadding: 0.5rem;\n\t\tborder: 1px solid var(--color-dark);\n\t\tborder-radius: 0.8rem;\n\t\tcursor: pointer;\n\t\tmargin-bottom: 1rem;\n\t}\n\t&_selectedItem {\n\t\tfont-size: 1.2rem;\n\t\tpadding: 0.5rem;\n\t\tborder: 1px solid var(--color-dark);\n\t\tborder-radius: 0.8rem;\n\t\tcursor: pointer;\n\t\tcolor: var(--color-white);\n\t\tfont-weight: 700;\n\t\tbackground-color: var(--color-dark);\n\t\tmargin-bottom: 1rem;\n\t}\n}\n\n.cpt {\n\tdisplay: flex;\n\tfont-size: var(--default-font-small);\n\twidth: 38rem;\n\toverflow-x: scroll;\n\t&::-webkit-scrollbar {\n\t\twidth: 1rem;\n\t\tbackground-color: var(--color-white);\n\t\tborder-radius: 0 1rem 1rem 0;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground-color: var(--color-grey);\n\t\tborder-radius: 1rem;\n\t}\n\n\t&_action {\n\t\tfont-weight: 700;\n\t\tcolor: var(--color-primary);\n\t\tcursor: pointer;\n\t\ttext-decoration: underline;\n\t}\n\n\ttr {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tpadding: 2rem;\n\t}\n\n\tthead {\n\t\tbackground-color: var(--color-grey-3);\n\t\twidth: 19rem;\n\t\tposition: fixed;\n\t\tz-index: 2;\n\t}\n\ttbody {\n\t\tposition: relative;\n\t\tleft: 50%;\n\t\tdisplay: flex;\n\t\ttr {\n\t\t\tbackground-color: var(--color-light);\n\t\t\twidth: 19rem;\n\n\t\t\t&:nth-child(even) {\n\t\t\t\tbackground-color: var(--color-white);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.beneficiary {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tbox-sizing: border-box;\n\tfont-size: var(--default-font-small);\n\twidth: 38rem;\n\n\tmargin-bottom: 3rem;\n\tcursor: pointer;\n\n\t& > * {\n\t\tpadding: 1rem 0 1rem 0;\n\t\ttext-align: center;\n\t}\n\n\t&__saved {\n\t\tbackground-color: var(--color-primary);\n\t\tcolor: var(--color-white);\n\t\tborder-radius: 1rem 0 0 1rem;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tborder-radius: 1rem 0 0 1rem;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n\n\t&__new {\n\t\tborder: 1px solid var(--color-primary);\n\t\tborder-radius: 0 1rem 1rem 0;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tbackground-color: var(--color-primary);\n\t\t\tcolor: var(--color-white);\n\t\t\tborder-radius: 0 1rem 1rem 0;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n}\n\n.unit {\n\t&_group {\n\t\twidth: 38rem;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(2, 50%);\n\t\tgap: 2rem;\n\t}\n\n\t&_card {\n\t\tbackground-color: var(--color-primary-3);\n\t\tpadding: 2rem;\n\t\tbox-sizing: border-box;\n\t\tborder-radius: 2rem;\n\t\tfont-size: 4rem;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-direction: column;\n\t\tcolor: var(--color-primary);\n\t\tcursor: pointer;\n\t\ttransition: all 0.4s;\n\n\t\t&:hover {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal__img": `Employees_modal__img__O1teN`,
	"main_nav": `Employees_main_nav__l2UGr`,
	"main_nav_group": `Employees_main_nav_group__6kpJ4`,
	"main_nav_more": `Employees_main_nav_more__nGDQk`,
	"main_nav_item": `Employees_main_nav_item__v+R3s`,
	"main__metrics": `Employees_main__metrics__cr8BR`,
	"main__metrics_active": `Employees_main__metrics_active__nmeii`,
	"main__metrics_suspended": `Employees_main__metrics_suspended__nS7jI`,
	"main__metrics_terminated": `Employees_main__metrics_terminated__GZiPO`,
	"main__dropdowns": `Employees_main__dropdowns__03GBZ`,
	"payroll_table": `Employees_payroll_table__FOeN+`,
	"status__pending": `Employees_status__pending__Pylnb`,
	"status__paid": `Employees_status__paid__nVplt`,
	"status__failed": `Employees_status__failed__jxMeo`,
	"employee__list": `Employees_employee__list__1JVFb`,
	"employee__list_line": `Employees_employee__list_line__vj8FF`,
	"employee__avatar": `Employees_employee__avatar__G5rsO`,
	"employee__avatar_container": `Employees_employee__avatar_container__E3umF`,
	"employee__details": `Employees_employee__details__2nf8l`,
	"employee__editButton": `Employees_employee__editButton__3ObV8`,
	"employee__terminate": `Employees_employee__terminate__jXrst`,
	"employee_table": `Employees_employee_table__y1O5y`,
	"crumbs": `Employees_crumbs__eqZhI`,
	"crumbs__main": `Employees_crumbs__main__VMfqa`,
	"crumbs__active": `Employees_crumbs__active__QkU8K`,
	"checks": `Employees_checks__W5+wT`,
	"checks_group": `Employees_checks_group__4O9wg`,
	"gp": `Employees_gp__TyFVa`,
	"gp__vb": `Employees_gp__vb__fHJBB`,
	"gp__vps": `Employees_gp__vps__VVdDK`,
	"gp__top": `Employees_gp__top__canHY`,
	"ps": `Employees_ps__Tglf+`,
	"ps__breakdown": `Employees_ps__breakdown__oXp7G`,
	"ps__breakdown_sm": `Employees_ps__breakdown_sm__JPWtB`,
	"ps__breakdown_bdr": `Employees_ps__breakdown_bdr__ByQl+`,
	"ps__breakdown_total": `Employees_ps__breakdown_total__1AC1c`,
	"mp": `Employees_mp__Ue2DD`,
	"success": `Employees_success__I3dKY`,
	"simpleTable": `Employees_simpleTable__YSclX`,
	"pending": `Employees_pending__WuNBH`,
	"paid": `Employees_paid__X5mMf`,
	"failed": `Employees_failed__YzBHY`,
	"others": `Employees_others__rBVOq`,
	"change": `Employees_change__MWNPO`,
	"action__text": `Employees_action__text__zJqyc`,
	"filter": `Employees_filter__Q8r32`,
	"filter_title": `Employees_filter_title__NBjUX`,
	"filter_group": `Employees_filter_group__IIwzg`,
	"filter_item": `Employees_filter_item__ZCidk`,
	"filter_selectedItem": `Employees_filter_selectedItem__CHkss`,
	"cpt": `Employees_cpt__21wmP`,
	"cpt_action": `Employees_cpt_action__78VjD`,
	"beneficiary": `Employees_beneficiary__oE+3p`,
	"beneficiary__saved": `Employees_beneficiary__saved__H+iUN`,
	"beneficiary__saved_b": `Employees_beneficiary__saved_b__3Oczd`,
	"beneficiary__new": `Employees_beneficiary__new__jeg3P`,
	"beneficiary__new_b": `Employees_beneficiary__new_b__jgysk`,
	"unit_group": `Employees_unit_group__DIONm`,
	"unit_card": `Employees_unit_card__G0gt4`
};
export default ___CSS_LOADER_EXPORT___;
